// extracted by mini-css-extract-plugin
export default {"title":"styles_title__fiwfh","head":"styles_head__p8g6E"};